<section class="section">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg col-md-3 mt-2">
                <div class="form-floating">
                    <select class="form-select" id="floatingSelect" aria-label="Floating label select example"
                        (change)="updateDetails($event,'date')" [(ngModel)]="billDate">
                        <option selected disabled value="">Select Bill Date</option>
                        <option value="all">All</option>
                        <option *ngFor="let date of this.billDateDetails">{{date}}</option>
                    </select>
                    <label for="floatingSelect">Bill Date</label>
                </div>
            </div>

            <div class="col-lg col-md-3 mt-2">
                <div class="form-floating">
                    <select class="form-select" id="floatingSelect" aria-label="Floating label select example"
                        (change)="updateDetails($event,'status')" [(ngModel)]="billTypes">
                        <option selected disabled value="">Select Bill Type</option>
                        <option value="all">All</option>
                        <option *ngFor="let status of this.billTypeDetails">{{status}}</option>
                    </select>
                    <label for="floatingSelect">Bill Type</label>
                </div>
            </div>

            <div class="col-lg col-md-3 mt-2">
                <div class="form-floating">
                    <select class="form-select" id="floatingSelect" aria-label="Floating label select example"
                        (change)="updateDetails($event,'payment')" [(ngModel)]="paymentTypes">
                        <option selected disabled value="">Select Payment Type</option>
                        <option value="all">All</option>
                        <option *ngFor="let payment of this.paymentTypesDetails">{{payment}}</option>
                    </select>
                    <label for="floatingSelect">Payment Type</label>
                </div>
            </div>

            <div class="col-lg col-md mt-2">
                <div class="form-floating">
                    <input type="text" class="form-control" placeholder="sale amount"
                        [value]="getFormattedCurrency(totalSaleAmount)" readonly>
                    <label class="text-gray">Total Sale Amount</label>
                </div>
            </div>
            <div class="col-lg col-md mt-2 d-flex justify-content-end">
                <button class="btn btn-danger mt-2" (click)="resetReviewFilter()">Clear Filters <img class="img-fluid"
                        alt="clear" src="assets/img/icons/clear-alt.png"></button>
            </div>
        </div>


        <div class="mt-3"></div>
        <div class="row">
            <div class="col-lg-2 col-md-3 mt-2">
                <div class="form-floating">
                    <input type="date" [(ngModel)]="fromDate" class="form-control" (change)="onDate()"
                        [max]="toDate || todayMax">
                    <label for="fromDate">From Date:</label>
                </div>
            </div>
            <div class="col-lg-2 col-md-3 mt-2">
                <div class="form-floating">
                    <input type="date" [(ngModel)]="toDate" class="form-control" (change)="onDate()" [max]="todayMax">
                    <label for="toDate">To Date:</label>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 mt-2">
                <div class="form-floating">
                    <input type="search" class="form-control" placeholder="search" [(ngModel)]="searchText">
                    <label class="text-gray">Search</label>
                </div>
            </div>

            <div class=" col-lg col-md-12 mt-2 d-flex justify-content-end">
                <button class="btn btn-success mt-2 me-3" (click)="downloadExcel()">Download Excel <i
                        class="bi bi-file-earmark-excel"></i></button>
                <button class="btn btn-primary mt-2 me-3" (click)="downloadPDF()">Download PDF <i
                        class="fa-solid fa-file-pdf"></i>
                </button>
                <button class="btn btn-success mt-2" (click)="downloadGSTReport()">
                    Download GST Report <i class="bi bi-file-earmark-excel"></i>
                </button>
            </div>

        </div>


        <div class="py-2"></div>


        <div class="container-fluid">
            <div class="table-style table-responsive table-bordered">
                <table class="table table-head-fixed text-nowrap text-center">
                    <thead>
                        <tr class="sticky-top">
                            <th>S.No</th>
                            <th>Customer Name</th>
                            <th>Phone Number</th>
                            <th>City</th>
                            <th>Bill Date</th>
                            <th>Bill Type</th>
                            <th>Invoice Number</th>
                            <th>Bill Amount</th>
                            <th>Product Discount</th>
                            <th>Manual Discount</th>
                            <th>Total Amount</th>
                            <th>Paid Amount</th>
                            <th>Admin Approval</th>
                            <th>Print</th>
                            <th>Edit</th>
                            <th>Cancellation</th>
                        </tr>
                    </thead>
                    <tbody class="text-center"
                        *ngIf="(shopBillDetails | filter:searchText).length > 0; else noDataFound">
                        <tr *ngFor="let item of this.shopBillDetails | filter: searchText; let i = index">
                            <td>{{i + 1}}</td>
                            <td>{{item?.customerName || "-"}}</td>
                            <td>{{item?.phoneNumber || "-"}}</td>
                            <td>{{item?.city || "-"}}</td>
                            <td>{{item?.createdAt | date : "dd-MM-yyy / hh:mm:ss aa"}}</td>
                            <td>{{item?.billingType || "-"}}</td>
                            <td>{{item?.invoiceNumber || "-"}}</td>
                            <td>{{ getFormattedAmount (item?.subTotal) || "-" }}</td>
                            <td>{{ getFormattedAmount (item?.discount) || "-" }}</td>
                            <td>{{ getFormattedAmount (item?.manualDiscountAmount) || "-" }}</td>
                            <td>{{ getFormattedAmount(getGrandTotal(item)) || "-"}}</td>
                            <td>{{ getFormattedAmount (item?.totalAmount) || "-" }}</td>
                            <td>

                                <!-- Draft bill - no approval option -->
                                <span *ngIf="item?.isDraft === true" class="text-block fw-bold">
                                    Draft
                                </span>

                                <!-- Non-draft bill -->
                                <ng-container *ngIf="item?.isDraft !== true">

                                    <!-- Already approved -->
                                    <span *ngIf="item?.adminStatus === 'APPROVED'" class="badge bg-success">
                                        Approved
                                    </span>

                                    <!-- Not approved -->
                                    <button *ngIf="item?.adminStatus !== 'APPROVED' && this.userType == 'SUPER_ADMIN' && item?.billingStatus != 'CANCELLED'"
                                        class="btn btn-warning btn-sm rounded-pill"
                                        (click)="updateAdminStatus(item?.billId)">
                                        Approve
                                    </button>
                                    
                                    <span *ngIf="item?.adminStatus !== 'APPROVED' && this.userType != 'SUPER_ADMIN'">--</span>

                                </ng-container>

                            </td>

                            <td>
                                <button class="btn btn-md btn-info text- rounded-pill"
                                    (click)="printBill(item?.billId,item?.buyerType)">Print <i
                                        class="fas fa-print"></i></button>
                            </td>
                            <td>
                                <span *ngIf="item?.billingType != 'ECOMMERCE' && item?.billingStatus != 'CANCELLED'"
                                    class=""><button class="btn btn-success rounded-pill"
                                        (click)="editShow(item?.billId)">Edit<span
                                            class="fas fa-pen ms-2"></span></button>
                                </span>
                                <span *ngIf="item?.billingType=='ECOMMERCE' || item?.billingStatus === 'CANCELLED'"> -
                                </span>
                            </td>
                            <td>
                                <button *ngIf="item?.billingStatus != 'CANCELLED' " class="btn btn-danger rounded-pill"
                                    (click)="cancelPopup(item?.billId)">Cancel<span
                                        class="fas fa-cancel ms-2"></span></button>
                                <span *ngIf="item?.billingStatus === 'CANCELLED'" class="me-2">Cancelled</span>
                            </td>
                        </tr>
                    </tbody>
                    <ng-template #noDataFound>
                        <tr class="text-center ubuntu-bold h6 text-danger">
                            <td colspan="12">Data Not Found</td>
                        </tr>
                    </ng-template>
                </table>
            </div>
        </div>
    </div>
</section>